import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import InboxPreviewPurchasePanelWithContext from './InboxPreviewPurchasePanelWithContext';
import { getInboxPreviewPricing } from '../../constants/inboxPreviewPricing';
import './AddInboxPreview.scss';

const ibpExpansionVideo = 'https://embed-ssl.wistia.com/deliveries/2b9a3dec70db2f1a290cb0ebbebd1eb0df693154.mp4';

const AddInboxPreview = ({ customer }) => {
  const { t } = useTranslation();

  // Get customer info to determine pricing
  const countryCode = customer?.getCountryCode();

  const { price } = getInboxPreviewPricing(countryCode);

  return (
    <div className="inbox-preview-page">
      <div id="purchaseForm" className="inbox_preview-view" data-qe-id="inbox_preview-upsell">
        <div className="inbox_preview-content">
          <div className="inbox_preview-content__text">
            <Trans i18nKey="add-inbox-preview.sub-header" values={{ price }}>
              <h1>header</h1>
              <p className="inbox_preview-view__subheading" data-qe-id="purchase-upsell-text">
                sub-header
              </p>
            </Trans>
          </div>
          <div className="inbox_preview-content__image">
            <video
              src={ibpExpansionVideo}
              className="inbox_preview-view__image"
              data-qe-id="purchase-upsell-graphic"
              loop
              autoPlay
              muted
              playsInline
            />
          </div>
        </div>
        <InboxPreviewPurchasePanelWithContext customer={customer} />
        <div className="inbox_preview-footer">
          <img
            src="https://static.ctctcdn.com/ui/images1/ao-ui/ctct_watermark_logo_200x34.svg"
            alt={t('add-inbox-preview.constant-contact-logo-alt')}
            data-qe-id="purchase-upsell-logo"
          />
        </div>
      </div>
    </div>
  );
};

AddInboxPreview.propTypes = {
  customer: PropTypes.shape({
    getCountryCode: PropTypes.func,
  }),
};

export default AddInboxPreview;
